import React from 'react'
import { css } from '@emotion/react'
import { toUnitNumber } from '@/lib/number'
import { Valuation } from '../../../../../types/api'
import { DateNote } from '../domestic/CompanySummary'
import { SummaryLabel } from './OverseasCompanySummary'
import { SummaryAmountWithCurrency } from './SummaryAmountWithCurrency'
import { font } from 'plume-ui'

type Props = {
  valuation: Valuation | null
}

export const ValuationInfo: React.VFC<Props> = (props) => {
  if (!props.valuation)
    return (
      <div
        className="valuation"
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
        `}
      >
        <SummaryLabel>調達後評価額</SummaryLabel>
        <div
          className="value"
          css={css`
            font-style: normal;
            font-weight: ${font.weight.normal};
            font-size: 32px;
            height: 48px;
            display: flex;
            align-items: center;
            line-height: 75%;
          `}
        >
          -
        </div>
      </div>
    )
  const unitNumber = toUnitNumber(props.valuation.value)
  return (
    <div
      className="valuation"
      css={css`
        display: flex;
        width: 176px;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
      `}
    >
      <SummaryLabel>調達後評価額</SummaryLabel>
      <div
        className="values"
        css={css`
          display: flex;
          height: 48px;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        `}
      >
        <SummaryAmountWithCurrency
          amount={unitNumber}
          currency={props.valuation.currency}
        />
      </div>
      <DateNote date={props.valuation.date} suffix="時点" className="date" />
    </div>
  )
}
